<nz-card class="card">
    <nz-skeleton
        [nzActive]="true"
        [nzLoading]="true"
        [nzTitle]="true"
        [nzParagraph]="{ rows: 7 }">
    </nz-skeleton>
</nz-card>
